import gql from "graphql-tag";
import { CategoryInfoFragment, ProductInfoFragment } from "./fragments";

export const allProductsQuery = gql`
  query allProducts($queries: ProductsFetchQueries!) {
    allProducts(queries: $queries) {
      data {
        products {
          ...ProductInfo
        }
        countTotal
        totalPages
        currentPage
      }
      message
      statusCode
    }
  }
  ${ProductInfoFragment}
`;

export const productByCodeQuery = gql`
  query productByCode($params: ProductByCodeFetchParams!) {
    productByCode(params: $params) {
      statusCode
      message
      data {
        ...ProductInfo
      }
    }
  }
  ${ProductInfoFragment}
`;

export const allCategoriesQuery = gql`
  query allCategories($queries: CategoriesFetchQueries) {
    allCategories(queries: $queries) {
      statusCode
      message
      data {
        categories {
          ...CategoryInfo
        }
      }
    }
  }
  ${CategoryInfoFragment}
`;
